import { cartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartLineQuantityStyles.editableQuantityTextField = {
    labelProps: {
        variant: "legend",

        css: css`
            font-size: 10px;
            font-weight: 600;
        `,
    },
    cssOverrides: {
        inputSelect: css`
            border: 1px solid ${getColor("common.border")} !important;
        `,
    },
    
};

cartLineQuantityStyles.readOnlyQuantityText={
    extendedStyles:{
        heading:{
            css:css`
            text-transform: uppercase;
            @media print{
           
            font-size:12px;
            }
       
        `
        }
    }

}

